<div class="column spacing-24" style="padding-bottom: 72px">
	<app-not-authorized-notice [hasOne]="['propertyManagement']"></app-not-authorized-notice>

	<div class="content-container" [appHasSystemCapability] [hasOne]="['propertyManagement']">
		<div class="content-container-body" style="margin-bottom: 0px">
			<h3 style="margin-bottom: 24px"><b i18n="@@addPropertyDetails-propertyDetails">Property Details</b></h3>

			<mat-divider></mat-divider>
		</div>

		<div class="content-container-body column spacing-24">
			<div class="row spacing-24">
				<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
					<mat-label class="mat-label-color" i18n="@@addPropertyDetails-Name"
						>Property Name
						<span class="asterisk-symbol" data-automation-id="propertyDetail-propertyNameInput-required"
							>*</span
						></mat-label
					>
					<input
						[disabled]="false"
						matInput
						[(ngModel)]="editProperty.name"
						name="name"
						required
						maxLength="100"
						data-automation-id="property-name-input"
					/>
				</mat-form-field>
				<div class="column"></div>
				<div class="column"></div>
			</div>

			<div class="row spacing-24">
				<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
					<mat-label class="mat-label-color">{{ this.latitudeLabel }}</mat-label>
					<input
						[disabled]="false"
						matInput
						[(ngModel)]="editProperty.latitude"
						(ngModelChange)="setLatitudeLabel()"
						name="latitude"
						data-automation-id="latitude-input"
					/>
				</mat-form-field>
				<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
					<mat-label class="mat-label-color">{{ this.longitudeLabel }}</mat-label>
					<input
						[disabled]="false"
						matInput
						[(ngModel)]="editProperty.longitude"
						(ngModelChange)="setLongitudeLabel()"
						name="longitude"
						data-automation-id="longitude-input"
					/>
				</mat-form-field>
				<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
					<mat-label class="mat-label-color" i18n="@@addPropertyDetails-Timezone"
						>Timezone
						<span class="asterisk-symbol" data-automation-id="propertyDetail-timeZoneInput-required">*</span></mat-label
					>
					<input
						type="text"
						aria-label="Timezone"
						matInput
						[matAutocomplete]="timezone"
						name="timezone"
						autocomplete="timezone"
						[(ngModel)]="editProperty.timezone"
						(ngModelChange)="filterTimezones($event)"
						(click)="openAutocompleteTimezones()"
						(input)="timezoneInput()"
						data-automation-id="timezone-input"
						required
					/>
					<mat-autocomplete
						#timezone="matAutocomplete"
						[displayWith]="displayTimezoneName"
						(optionSelected)="timezoneSelected()"
						data-automation-id="timezone-picker"
					>
						@for (timezone of filteredTimezones | async; track timezone.timezone) {
							<mat-option
								[value]="timezone.timezone"
								[attr.data-automation-id]="'timezone-option-' + timezone.timezone"
							>
								{{ timezone.timezone }} - {{ timezone.description }}
							</mat-option>
						}
					</mat-autocomplete>
					@if (showTimezoneError) {
						<mat-hint i18n="@@addPropertyDetails-TimezoneError" data-automation-id="timezone-error">
							Please select a Timezone from the list
						</mat-hint>
					}
				</mat-form-field>
			</div>

			<mat-divider></mat-divider>

			<div class="row spacing-24">
				<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
					<mat-label class="mat-label-color" i18n="@@addPropertyDetails-Street"
						>Street Address
						<span class="asterisk-symbol" data-automation-id="propertyDetail-streetAddressInput-required"
							>*</span
						></mat-label
					>
					<input
						[disabled]="false"
						matInput
						[(ngModel)]="editProperty.address1"
						name="address1"
						maxLength="100"
						data-automation-id="address-input"
						required
					/>
				</mat-form-field>
				<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
					<mat-label class="mat-label-color" i18n="@@addPropertyDetails-Apartment">Apartment/Suite</mat-label>
					<input
						[disabled]="false"
						matInput
						[(ngModel)]="editProperty.address2"
						name="address2"
						maxLength="100"
						data-automation-id="apartment-input"
					/>
				</mat-form-field>
				<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
					<mat-label class="mat-label-color" i18n="@@addPropertyDetails-Town"
						>Town/City
						<span class="asterisk-symbol" data-automation-id="propertyDetail-cityInput-required">*</span></mat-label
					>
					<input
						[disabled]="false"
						matInput
						[(ngModel)]="editProperty.locality"
						name="locality"
						maxLength="100"
						data-automation-id="city-input"
						required
					/>
				</mat-form-field>
			</div>

			<div class="row spacing-24">
				<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
					<mat-label class="mat-label-color" i18n="@@addPropertyDetails-State"
						>State/Province
						<span class="asterisk-symbol" data-automation-id="propertyDetail-stateInput-required">*</span></mat-label
					>
					<input
						[disabled]="false"
						matInput
						[(ngModel)]="editProperty.stateProvinceRegion"
						name="stateProvenceRegion"
						maxLength="100"
						data-automation-id="province-input"
						required
					/>
				</mat-form-field>

				<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
					<mat-label class="mat-label-color" i18n="@@addPropertyDetails-Postal"
						>Postal Code
						<span class="asterisk-symbol" data-automation-id="propertyDetail-postalCodeInput-required"
							>*</span
						></mat-label
					>
					<input
						[disabled]="false"
						matInput
						[(ngModel)]="editProperty.postalCode"
						name="postalCode"
						maxLength="18"
						data-automation-id="postal-code-input"
						required
					/>
				</mat-form-field>

				<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
					<mat-label class="mat-label-color" i18n="@@addPropertyDetails-Country"
						>Country
						<span class="asterisk-symbol" data-automation-id="propertyDetail-countryInput-required">*</span></mat-label
					>
					<input
						type="text"
						data-automation-id="country-input"
						aria-label="Country"
						matInput
						[matAutocomplete]="auto"
						name="countryCode"
						autocomplete="countryCode"
						[(ngModel)]="editProperty.countryCode"
						(ngModelChange)="filterCountries($event)"
						(click)="openAutocompleteCountries()"
						(input)="countryInput()"
						required
					/>
					<mat-autocomplete
						#auto="matAutocomplete"
						[displayWith]="displayCountryName"
						(optionSelected)="countrySelected()"
						data-automation-id="country-picker"
					>
						@for (country of filteredCountries | async; track country.twoLetterCode) {
							<mat-option
								[value]="country.twoLetterCode"
								[attr.data-automation-id]="'country-option-' + country.twoLetterCode"
							>
								{{ country.name }}
							</mat-option>
						}
					</mat-autocomplete>
					@if (showCountryError) {
						<mat-hint i18n="@@addPropertyDetails-CountryError" data-automation-id="country-error">
							Please select a Country from the list
						</mat-hint>
					}
				</mat-form-field>
			</div>
			<mat-divider></mat-divider>

			<div class="flex-container row-no-width">
				<div class="header-margin inline-label-margin" i18n="@@addPropertyDetails-DeviceInsalls">
					Devices to be installed:
				</div>
				<button
					mat-stroked-button
					(click)="decrementOnClick()"
					class="incremental-button"
					[appHasSystemCapability]
					has="deviceManagement"
					data-automation-id="add-property-details-decrement-button"
				>
					-
				</button>
				<input
					[(ngModel)]="this.editProperty.pendingInstalls"
					name="pendingInstalls"
					[disabled]="true"
					[readonly]="true"
					class="incremental-input"
					data-automation-id="add-property-details-increment-input"
				/>
				<button
					mat-stroked-button
					(click)="incrementOnClick()"
					class="incremental-button"
					[appHasSystemCapability]
					has="deviceManagement"
					data-automation-id="add-property-details-increment-button"
				>
					+
				</button>
			</div>
		</div>
	</div>
</div>
